import ApiService from "@/core/services/api.service";
import {SET_SNACK} from "@/core/services/store/snackbar.module";

// action types
export const DEVELOPMENTUNITDETAILS_LIST = "developmentunitdetails_list";
export const CREATE_DEVELOPMENTUNITDETAILS = "create_developmentunitdetails";
export const UPDATE_DEVELOPMENTUNITDETAILS = "update_developmentunitdetails";
export const DELETE_DEVELOPMENTUNITDETAILS = "delete_developmentunitdetails";
export const GET_DEVELOPMENTUNITDETAILS_DETAILS = "get_developmentunitdetails_details";
export const GET_DEVELOPMENTUNITDETAILS_DETAILS_BY_UNIT_NUMBER = "get_developmentunitdetails_details_by_unit_number";
export const DEVELOPMENTUNITDETAILS_SIMPLE_LIST = "developmentunitdetails_simple_details";
export const CLEAR_DEVELOPMENTUNITDETAILS_ERRORS = "clearDevelopmentUnitDetailsErrors";

// mutation types
export const SET_DEVELOPMENTUNITDETAILS_ERROR = "setDevelopmentUnitDetailsErrors";
export const REMOVE_DEVELOPMENTUNITDETAILS_ERRORS = "removeDevelopmentUnitDetailsErrors";

const state = {
    errors: null,
    yearlyServiceCharges: '',
    monthlyCoolingCharges: ''
};
const actions = {
    [DEVELOPMENTUNITDETAILS_LIST](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.simpledatatable("api/developmentunitdetails?development_id=" + payload.development_id + '&' + payload.q + payload.columns.join(''))
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_DEVELOPMENTUNITDETAILS_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_DEVELOPMENTUNITDETAILS_ERROR, response.errors);
                });
        });
    },
    [CREATE_DEVELOPMENTUNITDETAILS](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/createdevelopmentunitdetail", payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_DEVELOPMENTUNITDETAILS_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_DEVELOPMENTUNITDETAILS_ERROR, response.errors);
                });
        });
    },
    [UPDATE_DEVELOPMENTUNITDETAILS](context, payload) {
        return new Promise(resolve => {
            return ApiService.update("api/updatedevelopmentunitdetail", payload.slug, payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_DEVELOPMENTUNITDETAILS_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_DEVELOPMENTUNITDETAILS_ERROR, response.errors);
                });
        });
    },
    [DELETE_DEVELOPMENTUNITDETAILS](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/deletedevelopmentunitdetail", payload).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_DEVELOPMENTUNITDETAILS_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_DEVELOPMENTUNITDETAILS_ERROR, response.errors);
                });
        });
    },
    [GET_DEVELOPMENTUNITDETAILS_DETAILS](context, id) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.get("api/getdevelopmentunitdetaildetail", id)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_DEVELOPMENTUNITDETAILS_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_DEVELOPMENTUNITDETAILS_ERROR, response.errors);
                });
        });
    },
    [GET_DEVELOPMENTUNITDETAILS_DETAILS_BY_UNIT_NUMBER](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.datatable("api/getdevelopmentunitdetaildetailbyunitnumber?development_id=" + payload.development_id + "&unit_no=" + payload.unit_no)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_DEVELOPMENTUNITDETAILS_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_DEVELOPMENTUNITDETAILS_ERROR, response.errors);
                });
        });
    },
    [CLEAR_DEVELOPMENTUNITDETAILS_ERRORS](context) {
        context.commit(REMOVE_DEVELOPMENTUNITDETAILS_ERRORS);
    },
    [DEVELOPMENTUNITDETAILS_SIMPLE_LIST]() {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.get("api/developmentunitdetailssimple")
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    }
                });
        });
    },
};

const mutations = {
    [SET_DEVELOPMENTUNITDETAILS_ERROR](state, error) {
        state.errors = error;
    },
    [REMOVE_DEVELOPMENTUNITDETAILS_ERRORS](state) {
        state.errors = {};
    }
};

export default {
    state,
    actions,
    mutations
};
